<template>
  <v-fade-transition mode="out-in">
    <div>
      <!-- Tambahkan Tempat Google Translate -->
      <div id="google_translate_element" class="translate-container"></div>
      <router-view />
    </div>
  </v-fade-transition>
</template>

<script>
export default {
  name: "App",
  metaInfo() {
    const routeDescription =
      this.$route.meta?.description ||
      "Mantap Berhijrah dengan PT Asuransi Takaful Umum";
    const fullUrl = `https://www.takafulumum.co.id${this.$route.fullPath}`;

    return {
      title: "ManTap Berhijrah",
      titleTemplate: "%s - PT Asuransi Takaful Umum",
      htmlAttrs: { lang: "id" },
      meta: [
        { charset: "utf-8" },
        { name: "viewport", content: "width=device-width, initial-scale=1" },
        { name: "description", content: routeDescription },
        { property: "og:title", content: "Takaful Umum - Mantap Berhijrah" },
        { property: "og:site_name", content: "PT Asuransi Takaful Umum" },
        { property: "og:type", content: "website" },
        { property: "og:url", content: fullUrl },
        {
          property: "og:image",
          content: "https://www.takafulumum.co.id/favicon-atu.png"
        },
        { property: "og:description", content: routeDescription }
      ],
      link: [{ rel: "canonical", href: fullUrl }]
    };
  },
  watch: {
    $route: {
      immediate: true,
      handler() {
        this.$meta().refresh();
        this.toggleTranslateVisibility();
      }
    }
  },
  mounted() {
    this.loadGoogleTranslate();
  },
  methods: {
    toggleTranslateVisibility() {
      const translateEl = document.getElementById("google_translate_element");
      if (!translateEl) {
        return;
      }

      const hiddenNames = [
        "login",
        "kalkulator-kontribusi",
        "kalkulator-kontribusi-bank",
        "karir"
      ];
      const hiddenPaths = [
        "/login",
        "/kalkulator-kontribusi",
        "kalkulator-kontribusi-bank",
        "/karir"
      ];
      const shouldHide =
        hiddenNames.includes(this.$route.name) ||
        hiddenPaths.includes(this.$route.path);
      translateEl.style.display = shouldHide ? "none" : "";
    },
    loadGoogleTranslate() {
      if (!window.google || !window.google.translate) {
        const script = document.createElement("script");
        script.src =
          "https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
        script.async = true;
        document.head.appendChild(script);

        window.googleTranslateElementInit = this.initGoogleTranslate;
      } else {
        this.initGoogleTranslate();
      }
    },
    initGoogleTranslate() {
      setTimeout(() => {
        if (document.getElementById("google_translate_element")) {
          new window.google.translate.TranslateElement(
            { pageLanguage: "id", autoDisplay: false },
            "google_translate_element"
          );
          this.toggleTranslateVisibility();
        }
      }, 500);
    }
  }
};
</script>

<style>
.translate-container {
  position: fixed;
  right: 10px;
  z-index: 1000;
}

.goog-te-gadget {
  font-size: 0;
}
.goog-te-gadget span {
  display: none;
}

.goog-te-combo {
  height: 35px;
  font-size: 14px;
  padding: 5px;
  border-radius: 5px;
}

.goog-te-banner-frame.skiptranslate {
  display: none !important;
}

body {
  top: 0px !important;
  position: static !important;
}
</style>
